import React, { PureComponent } from 'react'
import Toggle from 'react-toggle'
import styled from 'styled-components'
import '../../../node_modules/react-toggle/style.css'
import { PRIMARY_COLOR } from '../../styles/colors.style'
import HigherOrderField from './higher-order-field.component'
import { connect } from 'react-redux'
import { Creators as NewsletterCreators } from '../../ducks/newsletter-option/newsletter-option'

const StyledToggle = styled.div`
	display: inline-block;

	.react-toggle--checked .react-toggle-thumb {
		left: 25px;
		border-color: ${PRIMARY_COLOR};
	}

	.react-toggle-track {
		background: #cccccc;
		border: none;
		width: 50px;
		height: 26px;
	}

	.react-toggle--checked .react-toggle-track {
		background-color: ${PRIMARY_COLOR};
	}

	.react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
		background: #cccccc;
		border: none;
	}

	.react-toggle--checked:hover:not(.react-toggle--disabled)
		.react-toggle-track {
		background-color: ${PRIMARY_COLOR};
	}

	.react-toggle-thumb {
		width: 24px;
		height: 24px;
		border: none;
	}

	.react-toggle--focus .react-toggle-thumb {
		box-shadow: none;
	}
`

class BaseCheckboxToggleInput extends PureComponent {
	constructor(props) {
		super(props)
		const { elementRef } = this.props
		this.elementRef = elementRef || React.createRef()
	}

	render() {
		const { value, id, onChange, onBlur, setNewsletterOption, disabled } =
			this.props
		return (
			<HigherOrderField innerRef={this.elementRef} {...this.props}>
				<StyledToggle>
					<Toggle
						id={id}
						disabled={disabled}
						name={id}
						checked={value}
						icons={false}
						onChange={(e) => {
							if (id == 'newsletter') {
								setNewsletterOption(e.target.checked)
							}

							onChange(id, e.target.checked)
						}}
						onBlur={onBlur}
					/>
				</StyledToggle>
			</HigherOrderField>
		)
	}
}

const mapDispatchToProps = {
	setNewsletterOption: NewsletterCreators.setNewsletterOption,
}

const BaseCheckboxToggle = connect(
	null,
	mapDispatchToProps
)(BaseCheckboxToggleInput)

export default BaseCheckboxToggle
